import { gql } from "@apollo/client";
import { USER_FULL_INFO } from "../users/fragments";

export const STAFF_LOGIN = gql`
  mutation staffAreaLogin($email: String!, $password: String!, $otp: String) {
    staffAreaLogin(email: $email, password: $password, otp: $otp) {
      token
      refreshToken
      refreshExpiresIn
      requiresOtp
      sessionKey
      user {
        ...UserFullInfo
      }
    }
  }
  ${USER_FULL_INFO}
`;

// Deprecated: Use STAFF_LOGIN instead
export const ADMIN_LOGIN = STAFF_LOGIN;

export const REFRESH_TOKEN = gql`
  mutation refreshToken($token: String) {
    refreshToken(refreshToken: $token) {
      refreshExpiresIn
      token
      refreshToken
    }
  }
`;

export const LOGOUT_SESSION = gql`
  mutation logoutSession($sessionKey: String) {
    logoutSession(sessionKey: $sessionKey) {
      success
      message
    }
  }
`;

export const SET_2FA_METHOD = gql`
  mutation Set2FAMethod($method: TwoFAMethod!, $password: String!) {
    set2faMethod(method: $method, password: $password) {
      success
      message
      twoFaMethod
    }
  }
`;

export const CHANGE_PASSWORD_SECURE = gql`
  mutation ChangePasswordSecure(
    $oldPassword: String!
    $newPassword: String!
    $confirmPassword: String!
  ) {
    changePasswordSecure(
      oldPassword: $oldPassword
      newPassword: $newPassword
      confirmPassword: $confirmPassword
    ) {
      success
      message
    }
  }
`;

export const GOOGLE_OAUTH_LOGIN = gql`
  mutation AdminGoogleOauthLogin($accessToken: String!) {
    adminGoogleOauthLogin(accessToken: $accessToken) {
      success
      token
      refreshToken
      message
      user {
        ...UserFullInfo
      }
    }
  }
  ${USER_FULL_INFO}
`;

// Email Change Mutations (2-step verification for staff)
export const STAFF_REQUEST_EMAIL_CHANGE = gql`
  mutation staffRequestEmailChange(
    $newEmail: String!
    $confirmEmail: String!
    $password: String!
  ) {
    staffRequestEmailChange(
      newEmail: $newEmail
      confirmEmail: $confirmEmail
      password: $password
    ) {
      success
      message
    }
  }
`;

export const STAFF_CONFIRM_EMAIL_CHANGE = gql`
  mutation staffConfirmEmailChange($token: String!) {
    staffConfirmEmailChange(token: $token) {
      success
      message
      user {
        ...UserFullInfo
      }
    }
  }
  ${USER_FULL_INFO}
`;

// Deprecated mutations - not available in backend
// export const TERMINATE_SESSION = gql`...`;
// export const TERMINATE_ALL_SESSIONS = gql`...`;
// export const LOGIN_HISTORY_QUERY = gql`...`;
// export const ACTIVE_SESSIONS_QUERY = gql`...`;
